module.exports = "/img/logo.e335661b.svg";